// Translations for Royal Rooms B&B Website
export const translations = {
    it: {
        nav: {
            home: "Home",
            rooms: "Camere",
            about: "Chi Siamo",
            contact: "Contatti",
            bookNow: "Prenota Ora"
        },
        home: {
            heroTitle: "Royal Rooms",
            heroSubtitle: "Scopri Il Lusso Di Napoli",
            welcomeTitle: "Benvenuti a Royal Rooms B&B",
            welcomeText: "Benvenuti a Royal Rooms B&B, il vostro esclusivo rifugio di lusso nel cuore pulsante di Napoli! Situato in Piazza Garibaldi, 80, offriamo un'armoniosa fusione di comfort raffinato, eleganza senza tempo e convenienza senza pari, rendendoci la scelta privilegiata per viaggiatori esigenti che cercano un'esperienza indimenticabile. Le nostre camere sontuose e meticolosamente curate sono progettate per offrire il massimo comfort e un'atmosfera di puro lusso, mentre la nostra posizione strategica vi permette di esplorare facilmente le meraviglie mozzafiato di Napoli e della leggendaria Costiera Amalfitana.",
            roomsPreviewTitle: "Le Nostre Camere Esclusive",
            roomsPreviewSubtitle: "Ogni camera è un capolavoro di design, dove comfort raffinato incontra eleganza senza tempo",
            locationTitle: "Posizione Privilegiata Per Un Soggiorno Straordinario",
            locationText: "Situato direttamente di fronte alla Stazione Centrale di Napoli, Royal Rooms B&B offre la connettività perfetta per esplorare Napoli, la Costiera Amalfitana e oltre. La nostra posizione eccezionale vi permette di raggiungere facilmente le principali attrazioni turistiche, i ristoranti gourmet tradizionali e i punti di interesse più affascinanti della città.",
            locationCTA: "PRENOTA ORA LA TUA CAMERA",
            callNowTitle: "Chiamaci Ora",
            callNowText: "Per assistenza immediata o prenotazioni telefoniche"
        },
        rooms: {
            title: "Le Nostre Camere",
            subtitle: "Scegli la camera perfetta per il tuo soggiorno",
            filterAll: "Tutte",
            filterLuxury: "Luxury",
            filterDeluxe: "Deluxe",
            filterComfort: "Comfort",
            filterSuperior: "Superior",
            filterSweet: "Sweet",
            filterTwin: "Twin",
            luxury: {
                name: "Luxury",
                description: "La nostra camera più sontuosa e raffinata, adornata con arredi di lusso esclusivi, tessuti pregiati e una vista panoramica mozzafiato che cattura l'essenza di Napoli."
            },
            deluxe: {
                name: "Deluxe",
                description: "Ampia e straordinariamente confortevole, questa camera offre un'oasi di tranquillità perfetta per un soggiorno rigenerante e indimenticabile."
            },
            comfort: {
                name: "Comfort",
                description: "Design moderno e sofisticato, meticolosamente curato per offrire il massimo comfort e un'esperienza di soggiorno impeccabile."
            },
            superior: {
                name: "Superior",
                description: "Spaziosa e elegantemente arredata con attenzione ai dettagli, ideale per coppie e famiglie che cercano un'esperienza di lusso autentica."
            },
            sweet: {
                name: "Sweet",
                description: "Romantica e incredibilmente accogliente, questa camera è perfetta per una fuga romantica indimenticabile nel cuore di Napoli."
            },
            twin: {
                name: "Twin",
                description: "Due letti singoli di alta qualità, ideale per amici o colleghi di viaggio che cercano comfort e privacy in un ambiente elegante."
            },
            amenities: {
                title: "Servizi Inclusi",
                items: [
                    "Aria Condizionata",
                    "WiFi Ad Alta Velocità",
                    "Reception 24 Ore",
                    "TV a Schermo Piatto",
                    "Bagno Privato",
                    "Asciugacapelli",
                    "Set di Cortesia",
                    "Biancheria da Letto Premium"
                ]
            }
        },
        about: {
            heroTitle: "La Nostra Storia & Impegno",
            storyTitle: "Chi Siamo",
            storyText: "Royal Rooms B&B nasce dalla passione autentica per l'ospitalità di lusso e il desiderio ardente di offrire ai nostri ospiti un'esperienza straordinaria e indimenticabile nel cuore pulsante di Napoli. La nostra struttura esclusiva combina magistralmente l'eleganza moderna con il calore genuino dell'ospitalità italiana, creando un ambiente raffinato e accogliente dove ogni dettaglio è meticolosamente curato per garantire il massimo comfort e un'esperienza di soggiorno senza pari.",
            whyChooseUsTitle: "Perché Sceglierci",
            primeLocation: {
                title: "Posizione Privilegiata",
                description: "Strategicamente posizionati di fronte alla stazione centrale, la posizione perfetta per esplorare Napoli e le sue meraviglie."
            },
            elegantRooms: {
                title: "Camere Sontuose",
                description: "Design raffinato e arredi di alta qualità, ogni camera è un capolavoro di eleganza e comfort."
            },
            hospitality: {
                title: "Ospitalità Straordinaria",
                description: "Servizio impeccabile, cordiale e professionale, dedicato a rendere il vostro soggiorno un'esperienza indimenticabile."
            },
            deliciousBreakfast: {
                title: "Colazione Gourmet",
                description: "Iniziate la giornata con una deliziosa colazione italiana tradizionale, preparata con ingredienti freschi e di qualità."
            },
            easyAccessibility: {
                title: "Accessibilità Perfetta",
                description: "Facilmente raggiungibile con i mezzi pubblici e strategicamente vicino alle principali attrazioni e punti di interesse."
            }
        },
        contact: {
            title: "Sentiti Libero Di Contattarci",
            subtitle: "Siamo qui per aiutarti. Contattaci per qualsiasi domanda o prenotazione.",
            phone: "Telefono",
            email: "Email",
            address: "Indirizzo",
            form: {
                name: "Nome",
                email: "Email",
                subject: "Oggetto",
                message: "Messaggio",
                send: "Invia Messaggio",
                namePlaceholder: "Il tuo nome",
                emailPlaceholder: "la-tua-email@esempio.com",
                subjectPlaceholder: "Oggetto del messaggio",
                messagePlaceholder: "Scrivi il tuo messaggio qui..."
            }
        },
        footer: {
            description: "Royal Rooms B&B - Il tuo rifugio di lusso nel cuore di Napoli",
            rights: "Tutti i diritti riservati"
        }
    },
    en: {
        nav: {
            home: "Home",
            rooms: "Rooms",
            about: "About Us",
            contact: "Contact",
            bookNow: "Book Now"
        },
        home: {
            heroTitle: "Royal Rooms",
            heroSubtitle: "Discover The Luxury Of Naples",
            welcomeTitle: "Welcome to Royal Rooms B&B",
            welcomeText: "Welcome to Royal Rooms B&B, your exclusive luxury retreat in the vibrant heart of Naples! Situated at Piazza Garibaldi, 80, we offer a harmonious fusion of refined comfort, timeless elegance, and unparalleled convenience, making us the privileged choice for discerning travelers seeking an unforgettable experience. Our sumptuous and meticulously curated rooms are designed to provide maximum comfort and an atmosphere of pure luxury, while our strategic location allows you to easily explore the breathtaking wonders of Naples and the legendary Amalfi Coast.",
            roomsPreviewTitle: "Our Exclusive Rooms",
            roomsPreviewSubtitle: "Each room is a masterpiece of design, where refined comfort meets timeless elegance",
            locationTitle: "Prime Location For An Extraordinary Stay",
            locationText: "Located directly opposite Napoli Centrale Station, Royal Rooms B&B offers perfect connectivity to explore Naples, the Amalfi Coast, and beyond. Our exceptional location allows you to easily reach the main tourist attractions, traditional gourmet restaurants, and the most fascinating points of interest in the city.",
            locationCTA: "BOOK YOUR ROOM NOW",
            callNowTitle: "Call Us Now",
            callNowText: "For immediate assistance or phone reservations"
        },
        rooms: {
            title: "Our Rooms",
            subtitle: "Choose the perfect room for your stay",
            filterAll: "All",
            filterLuxury: "Luxury",
            filterDeluxe: "Deluxe",
            filterComfort: "Comfort",
            filterSuperior: "Superior",
            filterSweet: "Sweet",
            filterTwin: "Twin",
            luxury: {
                name: "Luxury",
                description: "Our most sumptuous and refined room, adorned with exclusive luxury furnishings, premium fabrics, and a breathtaking panoramic view that captures the essence of Naples."
            },
            deluxe: {
                name: "Deluxe",
                description: "Spacious and extraordinarily comfortable, this room offers an oasis of tranquility perfect for a rejuvenating and unforgettable stay."
            },
            comfort: {
                name: "Comfort",
                description: "Modern and sophisticated design, meticulously curated to offer maximum comfort and an impeccable stay experience."
            },
            superior: {
                name: "Superior",
                description: "Spacious and elegantly furnished with attention to detail, ideal for couples and families seeking an authentic luxury experience."
            },
            sweet: {
                name: "Sweet",
                description: "Romantic and incredibly welcoming, this room is perfect for an unforgettable romantic escape in the heart of Naples."
            },
            twin: {
                name: "Twin",
                description: "Two high-quality single beds, ideal for friends or travel companions seeking comfort and privacy in an elegant environment."
            },
            amenities: {
                title: "Included Amenities",
                items: [
                    "Air Conditioner",
                    "High Speed WiFi",
                    "24-Hour Front Desk",
                    "Flat Screen TV",
                    "Private Bathroom",
                    "Hair Dryer",
                    "Toiletries Set",
                    "Premium Bedding"
                ]
            }
        },
        about: {
            heroTitle: "Our Story & Commitment",
            storyTitle: "About Us",
            storyText: "Royal Rooms B&B was born from an authentic passion for luxury hospitality and the ardent desire to offer our guests an extraordinary and unforgettable experience in the vibrant heart of Naples. Our exclusive property masterfully combines modern elegance with the genuine warmth of Italian hospitality, creating a refined and welcoming environment where every detail is meticulously curated to ensure maximum comfort and an unparalleled stay experience.",
            whyChooseUsTitle: "Why Choose Us",
            primeLocation: {
                title: "Prime Location",
                description: "Strategically positioned opposite the central station, the perfect location to explore Naples and its wonders."
            },
            elegantRooms: {
                title: "Sumptuous Rooms",
                description: "Refined design and high-quality furnishings, each room is a masterpiece of elegance and comfort."
            },
            hospitality: {
                title: "Extraordinary Hospitality",
                description: "Impeccable, friendly, and professional service, dedicated to making your stay an unforgettable experience."
            },
            deliciousBreakfast: {
                title: "Gourmet Breakfast",
                description: "Start your day with a delicious traditional Italian breakfast, prepared with fresh, quality ingredients."
            },
            easyAccessibility: {
                title: "Perfect Accessibility",
                description: "Easily accessible by public transport and strategically close to main attractions and points of interest."
            }
        },
        contact: {
            title: "Feel Free To Contact Us",
            subtitle: "We're here to help. Contact us for any questions or reservations.",
            phone: "Phone",
            email: "Email",
            address: "Address",
            form: {
                name: "Name",
                email: "Email",
                subject: "Subject",
                message: "Message",
                send: "Send Message",
                namePlaceholder: "Your name",
                emailPlaceholder: "your-email@example.com",
                subjectPlaceholder: "Message subject",
                messagePlaceholder: "Write your message here..."
            }
        },
        footer: {
            description: "Royal Rooms B&B - Your luxury retreat in the heart of Naples",
            rights: "All rights reserved"
        }
    }
};

